import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import fivewhysimage from '../../assets/pageimages/FiveWhys.webp';
import logo from '../../assets/navlogo.png';

const CompleteRCAPDFGenerator = ({ rcaExtension }) => {
  const generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const lineHeight = 10;
    let yPosition = 20; 
    const imageWidth = 50; // Width of the image
    const imageHeight = 30; // Height of the image
    const imageMargin = 20; // Space below the image


    const addHeaderFooter = (data, isFooter = false) => {
    if (isFooter) {
      doc.setFontSize(8);
      doc.text('Powered by Think5Whys | www.think5whys.com', 10, doc.internal.pageSize.height - 10);
      doc.text(`Page ${data.pageCount}`, pageWidth - 20, doc.internal.pageSize.height - 10);
    } else {
      doc.setFontSize(14);
      doc.text('5 Whys Analysis', pageWidth / 2, 10, { align: 'center' });
      doc.setFontSize(11);
    }
  };

  const addText = (text, options = {}) => {
    const { fontSize = 12, color = [0, 0, 0] } = options; 
    doc.setFontSize(fontSize);
    doc.setTextColor(...color);
    const lines = doc.splitTextToSize(text, pageWidth - 20); 
    lines.forEach((line) => {
      if (yPosition + lineHeight > doc.internal.pageSize.height - 20) { 
        doc.addPage();
        addPageBreak();
        addHeaderFooter();
        yPosition = 20;
      }
      doc.text(line, 10, yPosition);
      yPosition += lineHeight;
    });
  };
  
  // Calculate image position
  const imageX = (pageWidth - imageWidth) / 2;
  const imageY = yPosition; // Start at the current yPosition

  // Add image to PDF, centered
  const addImageToPDF = (imageSrc, x, y, width, height) => {
    doc.addImage(imageSrc, 'PNG', x, y, width, height);
    yPosition = imageY + imageHeight + imageMargin; 
  };

   const addPageBreak = () => {
    doc.addPage();
    addHeaderFooter(); // Reapply header
    yPosition = 20;    // Reset yPosition for the new page
  };

  const addSpacer = (height) => {
    yPosition += height; // Move yPosition down by the specified height
  };

  const formatDateWithoutTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
};

    const formatDate = (date) => {
      if (date instanceof Date) {
        return formatDateWithoutTime(date);
      } else if (typeof date === 'string') {
        return date;
      } else {
        return 'N/A';
      }
    };

    const addTable = (title, items) => {
      addText(`${title}:`);
    //   const tableData = items.map(item => columns.map(col => item[col.dataKey] || 'N/A'));
    const tableData = items.map(item => [
        item.sn || 'N/A',
        item.details || 'N/A'
    ]);

    const columns = [
        { header: 'SN', dataKey: 'sn' },
        { header: 'Details', dataKey: 'details' }
    ];

    doc.autoTable({
        startY: yPosition,
        head: [columns.map(col => col.header)],
        body: tableData,
        theme: 'grid',
        margin: { top: 10 },
        styles: { fontSize: 10 },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 170 },
        },
        didDrawPage: (data) => {
          addHeaderFooter(data, true);
          },
      });

    yPosition = doc.autoTable.previous.finalY + 10; // Update yPosition to be just after the table
};

    const addActionTable = (title, items) => {
        addText(`${title}:`);
        const actionTableData = items.map(item => [
          item.sn || 'N/A',
          item.actionItem || 'N/A',
          item.who || 'N/A',
          item.priority || 'N/A',
          formatDateWithoutTime(item.startDate),
          formatDateWithoutTime(item.endDate),
          item.status || 'N/A',
          item.remarks || 'N/A'
        ]);
  
        const columns = [
          { header: 'SN', dataKey: 'sn' },
          { header: 'Action Item', dataKey: 'actionItem' },
          { header: 'Who', dataKey: 'who' },
          { header: 'Priority', dataKey: 'priority' },
          { header: 'Start Date', dataKey: 'startDate' },
          { header: 'End Date', dataKey: 'endDate' },
          { header: 'Status', dataKey: 'status' },
          { header: 'Remarks', dataKey: 'remarks' }
        ];
  
        doc.autoTable({
          startY: yPosition,
          head: [columns.map(col => col.header)],
          body: actionTableData,
          theme: 'grid',
          margin: { top: 10 },
          styles: { fontSize: 10 },
          columnStyles: {
            0: { cellWidth: 10 },
            1: { cellWidth: 40 },
            2: { cellWidth: 23 },
            3: { cellWidth: 18 },
            4: { cellWidth: 21 },
            5: { cellWidth: 21 },
            6: { cellWidth: 16 },
            7: { cellWidth: 25 }
          },
          didDrawPage: (data) => {
            addHeaderFooter(data, true);
            },
        });

  
        yPosition = doc.autoTable.previous.finalY + 10; // Update yPosition to be just after the table
      };

      
const addDialougeTreeInfoGraphics = (doc, record, options = {}) => {
  const {
    fontSize = 10,
    lineHeight = 10,
    viewWidth = 800,
    imageSrc = logo, // You can change the default image if needed
  } = options;

  // Set font size and initial positions
  doc.setFontSize(fontSize);
  
  // Add image
  doc.addImage(imageSrc, 'PNG', 50, 50, viewWidth / 2, viewWidth / 4);
  
  // Add spacer after image
  let yPosition = 50 + (viewWidth / 4) + 20;

  // Function to add text to the PDF
  const addText = (text, x, y) => {
    if (text) {
      doc.text(text, x, y);
    }
  };

  addText(`Title: ${record.title}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Problem Code: ${record.problemCode}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Category: ${record.category}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Sub Category: ${record.subCategory}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Problem Statement: ${record.problemStatement}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Why 1: ${record.why1}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Why 2: ${record.why2}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Why 3: ${record.why3}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Why 4: ${record.why4}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Why 5: ${record.why5}`, 10, yPosition);
  yPosition += lineHeight;
  addText(`Root Cause: ${record.rootCause}`, 10, yPosition);
  yPosition += lineHeight;

  // Add reasons for each Why
  for (let i = 1; i <= 5; i++) {
    if (record[`why${i}reasons`]) {
      record[`why${i}reasons`].forEach((reason, index) => {
        addText(`Why ${i} Reason ${index + 1}: ${reason.details}`, 10, yPosition);
        yPosition += lineHeight;
      });
    }
  }

  // Add root causes
  if (record.rcaCauses) {
    record.rcaCauses.forEach((cause, index) => {
      addText(`Root Cause ${index + 1}: ${cause.details}`, 10, yPosition);
      yPosition += lineHeight;
    });
  }
};

    addHeaderFooter(); 

    addImageToPDF(fivewhysimage, imageX, imageY, imageWidth, imageHeight);
    // addSpacer('50px');
    // addImageToPDF(logo, imageX, imageY+40, imageWidth, imageHeight);
    // addSpacer('50px');
    addText('Investigation Report', { fontSize: 18, color: [255, 0, 255] });

    addText(`Title: ${rcaExtension.concernArea}`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Opening Remarks: ${rcaExtension.openingRemarks || 'N/A'}`, { fontSize: 12, color: [0, 0, 0] });
    addText(`Closing Remarks: ${rcaExtension.closingRemarks || 'N/A'}`, { fontSize: 12, color: [0, 0, 0] });
    addText(`Expert Name: ${rcaExtension.expertName || 'N/A'}`, { fontSize: 12, color: [0, 0, 0] });
    addText(`Opening Date: ${rcaExtension.openingDate ? new Date(rcaExtension.openingDate).toLocaleDateString('en-GB') : 'N/A'}`, { fontSize: 12, color: [0, 0, 0] });
    addText(`Closing Date: ${rcaExtension.closingDate ? new Date(rcaExtension.closingDate).toLocaleDateString('en-GB') : 'N/A'}`, { fontSize: 12, color: [0, 0, 0] });
    addText(`Client Name: ${rcaExtension.clientName || 'N/A'}`, { fontSize: 12, color: [0, 0, 0] });
    addText(`Date Created: ${rcaExtension.dateCreated ? new Date(rcaExtension.dateCreated).toLocaleDateString('en-GB') : 'N/A'}`, { fontSize: 12, color: [0, 0, 0] });
    addPageBreak();

    addText(`Problem Statement:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.problemStatement}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Overall Impact:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.overallImpact}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Impact On:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.overallImpactOn}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Impact Severity:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.overallImpactSeverity}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Remarks: ${rcaExtension.problemStatementRemarks}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();

    addText(`Why1 Analysis`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Why1`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why1}`, { fontSize: 11, color: [0, 0, 0] });
    addTable('Reasons', rcaExtension.why1reasons, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Reason', dataKey: 'reason' }
    ]);
    addText(`Selected Why1 : ${rcaExtension.why1SelectedSN}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why1 Selection Reason:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why1SNSelectedReason}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Remarks`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why1remarks}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();
    
    addText(`Why2 Analysis`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Why2: ${rcaExtension.why2}`, { fontSize: 11, color: [0, 0, 0] });
    addTable('Reasons', rcaExtension.why2reasons, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Reason', dataKey: 'reason' }
    ]);
    addText(`Selected Why2: ${rcaExtension.why2SelectedSN}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why2 Selection Reason:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why2SNSelectedReason}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Remarks: ${rcaExtension.why2remarks}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why2remarks}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();

    addText(`Why3 Analysis`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Why3`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why3}`, { fontSize: 11, color: [0, 0, 0] });
    addTable('Reasons', rcaExtension.why3reasons, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Reason', dataKey: 'reason' }
    ]);
    addText(`Selected Why3:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why3SelectedSN}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why3 SN Selection Reason:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why3SNSelectedReason}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Remarks:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why3remarks}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();

    addText(`Why4 Analysis`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Why4:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why4}`, { fontSize: 11, color: [0, 0, 0] });
    addTable('Reasons', rcaExtension.why4reasons, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Reason', dataKey: 'reason' }
    ]);
    addText(`Selected Why4: ${rcaExtension.why4SelectedSN}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why4 Selection Reason:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why4SNSelectedReason}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why4 Remarks: ${rcaExtension.why4remarks}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();

    addText(`Why5 Analysis`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Why5:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why5}`, { fontSize: 11, color: [0, 0, 0] });
    addTable('Reasons', rcaExtension.why5reasons, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Reason', dataKey: 'reason' }
    ]);
    addText(`Selected Why5: ${rcaExtension.why5SelectedSN}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why5 Selection Reason:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why5SNSelectedReason}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why5 Remarks:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.why5remarks}`, { fontSize: 11, color: [0, 0, 0] });

    addPageBreak();

    addText(`Root Cause Analysis`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Root Cause:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.rootCause}`, { fontSize: 11, color: [0, 0, 0] });
    addTable('Causes', rcaExtension.rcaCauses, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Cause', dataKey: 'cause' }
    ]);
    addText(`Selected Cause: ${rcaExtension.selectedCause}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Remarks:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.rcaRemarks}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();

    addText(`Probable Solutions`, { fontSize: 12, color: [0, 0, 255] });
    addTable('Suggested Solutions', rcaExtension.probableSolutions, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Solution', dataKey: 'solution' }
    ]);
    addText(`Quick Fix Selected Solution: ${rcaExtension.selectedQFSolution}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Quick Fix Solution Remarks:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.selectedQFSolutionRemarks}`, { fontSize: 11, color: [0, 0, 0] });

    addText(`Long Term Selected Solution: ${rcaExtension.selectedLTSolution}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Selected LT Solution Remarks:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`${rcaExtension.selectedLTSolutionRemarks}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();

    addText(`Solution Actions Log`, { fontSize: 12, color: [0, 0, 255] });
    addActionTable('Solution Actions', rcaExtension.solutionActions, [
      { header: 'SN', dataKey: 'sn' },
      { header: 'Action Item', dataKey: 'actionItem' },
      { header: 'Who', dataKey: 'who' },
      { header: 'Priority', dataKey: 'priority' },
      { header: 'Start Date', dataKey: 'startDate' },
      { header: 'End Date', dataKey: 'endDate' },
      { header: 'Status', dataKey: 'status' },
      { header: 'Remarks', dataKey: 'remarks' }
    ]);
    addPageBreak();

    addText(`Study Kyewnote / Keyword, Measures & Outcome`, { fontSize: 12, color: [0, 0, 255] });
    addText(`Problem`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Problem Keywords: ${rcaExtension.problemKeywords}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Problem Measures: ${rcaExtension.problemMeasures}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Problem Outcome: ${rcaExtension.problemOutcome}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why1`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why1 Keywords: ${rcaExtension.why1Keywords}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why1 Measures: ${rcaExtension.why1Measures}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why1 Outcome: ${rcaExtension.why1Outcome}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why2`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why2 Keywords: ${rcaExtension.why2Keywords}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why2 Measures: ${rcaExtension.why2Measures}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why2 Outcome: ${rcaExtension.why2Outcome}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why3`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why3 Keywords: ${rcaExtension.why3Keywords}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why3 Measures: ${rcaExtension.why3Measures}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why3 Outcome: ${rcaExtension.why3Outcome}`, { fontSize: 11, color: [0, 0, 0] });
    addPageBreak();

    addText(`Why4`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why4 Keywords: ${rcaExtension.why4Keywords}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why4 Measures: ${rcaExtension.why4Measures}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why4 Outcome: ${rcaExtension.why4Outcome}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why5`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why5 Keywords: ${rcaExtension.why5Keywords}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why5 Measures: ${rcaExtension.why5Measures}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Why5 Outcome: ${rcaExtension.why5Outcome}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`RCA`, { fontSize: 11, color: [0, 0, 0] });
    addText(`RCA Keywords: ${rcaExtension.rcaKeywords}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`RCA Measures: ${rcaExtension.rcaMeasures}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`RCA Outcome: ${rcaExtension.rcaOutcome}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Actions:`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Effective Actions: ${rcaExtension.effectiveActions}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Actions Effectiveness: ${rcaExtension.actionsEffectiveness}`, { fontSize: 11, color: [0, 0, 0] });
    addText(`Action Remarks: ${rcaExtension.actionRemarks}`, { fontSize: 11, color: [0, 0, 0] });

    addHeaderFooter(true); 

    doc.save(`Think5Whys_RCA_Report_${rcaExtension.rcaCode}.pdf`);
  };

  return (
    <div className='w-80 ml-2 mr-2'>
      <button className="px-4 py-2" onClick={generatePDF}>Generate PDF</button>
    </div>
  );
};

export default CompleteRCAPDFGenerator;
